import styled from "styled-components";
import { mediaMaxWidth } from "../../../utils/mediaQueriesTemplate";

export const Wrapper = styled.div`
  display: flex;
  position: absolute;
  background-color: #fff;
  flex: 1;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 2;
  padding: 10px 0;
`;

export const CloseButton = styled.div`
  position: absolute;
  font-size: 1.4em;
  top: 6px;
  right: 20px;
  cursor: pointer;
  z-index: 2;

  svg {
    transition: 0.1s ease-in-out;
  }

  &:hover {
    svg {
      color: #79D9D9;
    }
  }

  ${mediaMaxWidth.tablet`
    top: 11px;
  `}
`;

export const Form = styled.form`
  margin: 0 auto;
  display: flex;
  flex: 1;
  padding: 0 15px;

  svg {
    margin-right: 10px;
  }

  ${mediaMaxWidth.smallDesktop`
    width: 280px;
  `}

  ${mediaMaxWidth.tablet`
    padding-top: 5px;
  `}

  ${mediaMaxWidth.phone`
    width: calc(100vw - 60px);
  `}
`;

export const EditorWrapper = styled.div`
  margin: 0;
  width: 100%;
  position: relative;

  .editor-toolbar {
    height: 30px;
    width: 270px;
    border: none;
    padding: 0;
    margin-bottom: 10px;

    .rdw-option-wrapper {
      border-radius: 4px;
      height: 30px;
      width: 35px;

      &:hover {
        border: 2px solid #402680;
        box-shadow: none;
      }
    }

    .rdw-option-wrapper.rdw-option-active {
      border: 2px solid #402680;
      box-shadow: none;

      &:hover {
        border: 2px solid #402680;
        box-shadow: none;
      }
    }
  }

  .rdw-editor-wrapper {
    word-break: break-word;
  }

  .editor {
    height: 140px;
    padding: 0 5px;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    font-size: 0.95em;
    padding: 5px 10px;
    margin: 0 5px;

    .public-DraftStyleDefault-block {
      margin: 0;
    }
  }

  ${mediaMaxWidth.smallDesktop`
    .editor {
      height: 140px;
    }
  `}

  ${mediaMaxWidth.phone`
    .editor {
      height: 135px;
    }
  `}
`;

export const Buttons = styled.div`
  position: absolute;
  right: 0;
  left: 0;
  bottom: 10px;
  display: flex;
  justify-content: space-between;
`;

export const SaveButton = styled.button`
  font-weight: bold;
  color: #fff;
  padding: 5px 25px;
  cursor: pointer;
  background: #79D9D9;
  border: 1px solid #79D9D9;
  text-transform: capitalize;
  box-sizing: border-box;
  border-radius: 4px;
  -webkit-transition: 0.15s ease-in-out;
  transition: 0.15s ease-in-out;
  width: 95px;
  margin: 0 auto;

  &:focus {
    outline: none;
  }

  &:hover {
    background: #79D9D9;
  }
`;

export const CancelButton = styled.button`
  font-weight: bold;
  color: #79D9D9;
  padding: 5px 25px;
  cursor: pointer;
  background: #fff;
  border: 1px solid #79D9D9;
  text-transform: capitalize;
  box-sizing: border-box;
  border-radius: 4px;
  -webkit-transition: 0.15s ease-in-out;
  transition: 0.15s ease-in-out;
  width: 100px;
  margin: 0 auto;

  &:focus {
    outline: none;
  }

  &:hover {
    background: #79D9D9;
    color: #fff;
  }
`;
